module.exports = __webpack_public_path__ + "img/tiptip-logo.d3537cd1.png";